// @ts-nocheck

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const GetSchedule = new ReduxAsyncAction('SCHEDULE_GET');
GetSchedule.registerRequest(function (schedule_id) {
  return dash_api.get(`/v1/schedule/${schedule_id}`).then(({ data }) => data);
});
export const getSchedule = GetSchedule.request;
export const SCHEDULE_GET = GetSchedule.constants;

const ListSchedule = new ReduxAsyncAction('SCHEDULE_LIST');
ListSchedule.registerRequest(function () {
  return dash_api.get(`/v1/schedule`).then(({ data }) => data);
});
export const listSchedule = ListSchedule.request;
export const SCHEDULE_LIST = ListSchedule.constants;

const CreateSchedule = new ReduxAsyncAction('SCHEDULE_CREATE');
CreateSchedule.registerRequest(function (body) {
  return dash_api.post(`/v1/schedule`, body).then(({ data }) => {
    return data;
  });
});
export const createSchedule = CreateSchedule.request;
export const SCHEDULE_CREATE = CreateSchedule.constants;

const UpdateSchedule = new ReduxAsyncAction('SCHEDULE_UPDATE');
UpdateSchedule.registerRequest(function (body) {
  return dash_api.put(`/v1/schedule`, body).then(({ data }) => {
    return data;
  });
});
export const updateSchedule = UpdateSchedule.request;
export const SCHEDULE_UPDATE = UpdateSchedule.constants;
